import {
  DemoIndicatorColoredIcon,
  PlaybookIcon,
  RecordingIndicatorColoredIcon,
  TourIndicatorColoredIcon,
} from '@carboncopyco/icons';
import type { Entity } from '@carboncopyco/types';
import classNames from 'classnames';
import type React from 'react';
import { stringToColor } from '../../utils';
import { Avatar } from '../Avatar';
import { TextBase } from '../Typography';

export const entityIcons: Record<
  Exclude<Entity, 'presentation' | 'overlay'>,
  React.ReactElement
> = {
  demo: <DemoIndicatorColoredIcon size={18} />,
  tour: <TourIndicatorColoredIcon size={18} />,
  record: <RecordingIndicatorColoredIcon size={18} />,
  playbook: <PlaybookIcon size={18} />,
};

export const renderCreatorItem = ({ checked, onChange, item }) => {
  return (
    <div className="px-2 h-9 cursor-pointer flex items-center w-full gap-2 focus:bg-ds-natural-50 focus:outline-none focus:rounded-md">
      <div className="flex items-center gap-3">
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
          className={classNames(
            `rounded-sm
              border
              outline-none
              active:outline-none
              active:ring-0
              active:ring-offset-0
              focus:outline-none
              focus:ring-0
              focus:ring-offset-0`,
            checked
              ? 'hover:text-ds-primary-400 text-ds-primary active:text-ds-primary-500 cursor-pointer'
              : `cursor-pointer
                   text-ds-primary
                   border-ds-natural-200
                   hover:border-ds-primary-400
                   active:border-ds-primary-500
                   `
          )}
        />
        <div className="flex items-center gap-2">
          <Avatar
            backgroundColor={stringToColor(item.label)}
            image={item.image}
            size="small"
            initials={item.label
              .split(' ')
              .map((word) => word[0])
              .join('')}
          />
          <TextBase
            color="text-ds-natural-600"
            label={item.label}
            ellipsis
          />
        </div>
      </div>
    </div>
  );
};
export const renderEntityItem = ({ checked, onChange, item }) => {
  return (
    <div className="px-2 h-9 cursor-pointer flex items-center w-full gap-2 focus:bg-ds-natural-50 focus:outline-none focus:rounded-md">
      <div className="flex items-center gap-3">
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
          className={classNames(
            `rounded-sm
              border
              outline-none
              active:outline-none
              active:ring-0
              active:ring-offset-0
              focus:outline-none
              focus:ring-0
              focus:ring-offset-0`,
            checked
              ? 'hover:text-ds-primary-400 text-ds-primary active:text-ds-primary-500 cursor-pointer'
              : `cursor-pointer
                   text-ds-primary
                   border-ds-natural-200
                   hover:border-ds-primary-400
                   active:border-ds-primary-500
                   `
          )}
        />
        <div className="flex items-center gap-2">
          {entityIcons[item.id]}
          <TextBase
            color="text-ds-natural-600"
            label={item.label}
            ellipsis
          />
        </div>
      </div>
    </div>
  );
};
